import React from "react";
import { connect } from "react-redux";
import {
  setNewRequestSelectionLevel,
  setNewRequestSetSelectedCity,
} from "../../redux/newRequest/newRequest.actions";
import { CitySubSingleStyled } from "./citySingle.styles";

const CitySubSingle = ({
  info,
  setNewRequestSetSelectedCity,
  setNewRequestSelectionLevel,
}) => {
  const handle_city_click = (info) => () => {
    setNewRequestSetSelectedCity(info);
    setNewRequestSelectionLevel(2);
  };

  return (
    <CitySubSingleStyled onClick={handle_city_click(info)}>
      {info.shahrname}
    </CitySubSingleStyled>
  );
};

const mapStateToProps = null;

const mapDispatchToProps = (dispatch) => ({
  setNewRequestSetSelectedCity: (x) =>
    dispatch(setNewRequestSetSelectedCity(x)),
  setNewRequestSelectionLevel: (x) => dispatch(setNewRequestSelectionLevel(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CitySubSingle);
